module.exports = __webpack_public_path__ + "static/img/5.d6aa0e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/eng/5.png
// module id = qEIk
// module chunks = 0